import { render, staticRenderFns } from "./UserRightsTable.vue?vue&type=template&id=416ec96a"
import script from "./UserRightsTable.vue?vue&type=script&lang=js"
export * from "./UserRightsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports